import { RouterProvider } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import { HelmetProvider } from 'react-helmet-async'
import QueryProvider from '@/components/providers/query-provider'
import { AppInitializerProvider } from '@/components/providers/app-initializer-provider'
import AppInitializerGate from '@/components/app-initializer/gate'
import DevMockUser from '@/components/dev-mock-user'
import { LoadingScreen } from '@/components/ui/spinner'
import i18n from '@/i18n/config'
import { router } from '@/routes'

export default function App() {
  return (
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <QueryProvider>
          <AppInitializerProvider>
            <AppInitializerGate loadingFallback={<LoadingScreen />}>
              <DevMockUser />
              <RouterProvider router={router} />
            </AppInitializerGate>
          </AppInitializerProvider>
        </QueryProvider>
      </I18nextProvider>
    </HelmetProvider>
  )
}
